import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  ElementRef,
  inject,
  input,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  NotificationConfig,
  NotificationData,
  NotificationService,
} from '@hypergraph/tapestry';
import { timer } from 'rxjs';
import {
  ApplicationMessageType,
  IApplicationMessage,
} from '../../infrastructure/ui/notifications/types';

@Component({
  selector: 'app-messages',
  imports: [CommonModule],
  templateUrl: './messages.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './messages.component.scss',
})
export class MessagesComponent implements OnInit {
  private service = inject(NotificationService);

  renderer: Renderer2 = inject(Renderer2);

  isHidden = true;
  private animationFinished = false;

  alertClass: string = 'alert-success';

  message = input<IApplicationMessage | null>(null);
  @ViewChild('alertMsg', { static: true }) alert!: ElementRef<any>;

  get messageClass(): string[] {
    const _cls = [this.alertClass];
    if (this.isHidden) {
      _cls.push('fade-out');
    }

    return _cls;
  }

  constructor() {
    effect(() => {
      if (this.message()) {
        this.alertClass = 'alert-success';
        if (this.message()?.type == ApplicationMessageType.ERROR) {
          this.alertClass = 'alert-danger';
        }
        if (this.message()?.type == ApplicationMessageType.INFO) {
          this.alertClass = 'alert-info';
        }
        this.showMessage();
      }
    });
  }

  ngOnInit(): void {
    requestAnimationFrame(() => {
      if (this.isHidden) {
        this.renderer.setStyle(this.alert.nativeElement, 'display', 'none');
      }
    });
  }

  showMessage() {
    this.isHidden = false;
    this.renderer.setStyle(this.alert.nativeElement, 'display', 'block');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        timer(5000).subscribe(() => {
          this.isHidden = true;
        });
      });
    });
    this.animationFinished = false;
  }

  onTransitionEnd(e: TransitionEvent) {
    if (e.propertyName == 'opacity') {
      requestAnimationFrame(() => {
        this.isHidden = true;
        this.renderer.setStyle(this.alert.nativeElement, 'display', 'none');
      });
      this.animationFinished = true;
    }
  }
}
